import React from 'react';
import { useLocation } from 'react-router-dom';
import { Typography, Button, Container } from '@sm/wds-react';
import { ROUTE_CONFIG } from '../PricingNavigation';
import audienceFeatures from './config/features';
import EnabledCheckMark from './components/EnabledCheckMark';
import DisabledCheckMark from './components/DisabledCheckMark';
import './audience-footer.scss';

const getUTSource = currentPath => {
  if (currentPath === ROUTE_CONFIG.teamsPricingPage.path) {
    return ROUTE_CONFIG.teamsPricingPage.queryString.ut_source;
  }

  if (currentPath === ROUTE_CONFIG.individualPricingPage.path) {
    return ROUTE_CONFIG.individualPricingPage.queryString.ut_source;
  }

  // by default return 'pricing' as ut source
  return 'pricing';
};

export const AudienceFooter = () => {
  const currentPath = useLocation().pathname;
  return (
    <Typography
      component="article"
      id="buy-targeted-responses"
      className="sm-audience-footer"
      data-testid="AudienceFooter"
    >
      <header>
        <Typography
          color="dark"
          component="h1"
          variant="cardTitle"
          align="center"
          className="sm-audience-footer__header"
        >
          SurveyMonkey Audience includes access to Paid Features
        </Typography>
      </header>

      <Container px={5} pt={4} pz={0} className="sm-audience-footer__content">
        <Container mt={4} mb={4}>
          <Typography component="p" className="sm-audience-footer__prompt">
            Get survey responses from around the world in minutes with
            <strong> SurveyMonkey Audience</strong>
          </Typography>
        </Container>

        <Container mt={3} mb={3}>
          <Typography component="p" className="sm-audience-footer__prompt">
            Target the types of people you want to hear from based on specific attributes, like country, gender, age,
            income, employment status, and more.
          </Typography>
        </Container>

        <Container mb={4}>
          <Button
            href={`/collect/audience/preview/?ut_source=${getUTSource(currentPath)}`}
            color="upgrade"
            data-testid="AudienceFooter__UpsellButton"
          >
            BUY TARGETED RESPONSES
          </Button>
        </Container>

        <Typography component="h2" variant="cardTitle" pt={8}>
          Advanced survey design and analysis features are included in the price of your Audience project.
        </Typography>

        <Container component="ul" flex flexWrap mt={1}>
          {audienceFeatures.map(feature => {
            return (
              <Container component="li" key={feature.name} className="sm-audience-footer__feature" m={1} p={2}>
                <Container mt={2} mr={2} className="sm-audience-footer__feature-status">
                  <Choose>
                    <When condition={feature.included}>
                      <EnabledCheckMark />
                    </When>
                    <Otherwise>
                      <DisabledCheckMark />
                    </Otherwise>
                  </Choose>
                </Container>
                <Container mt={1}>
                  <Typography color="dark">{feature.label}</Typography>
                </Container>
              </Container>
            );
          })}
        </Container>
      </Container>
    </Typography>
  );
};

export default AudienceFooter;
